import { Pipe, PipeTransform } from '@angular/core';
import { DealerGroupV } from '../models/dealership.model';

@Pipe({
    name: 'filterDealerGroupTable'
})
export class FilterDealerGroupTablePipe implements PipeTransform {

    transform(dealergroup: DealerGroupV[], filterText: string) {
        if (dealergroup == null)
            return null;
        return dealergroup.filter(c => {
            if (c.Name != null && c.Name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            return false;
        });
    }

}
